import React from "react";

const New = props => (
  <svg viewBox="0 0 26 26" {...props}>
    <g
      transform="translate(1 1)"
      stroke="currentColor"
      fill="none"
      fillRule="evenodd"
    >
      <circle strokeWidth={1.455} cx={11.922} cy={11.925} r={11.879} />
      <path
        strokeWidth={1.212}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.27 18.238l-4.306-2.226-4.274 2.286.785-4.783-3.493-3.357 4.79-.73 2.114-4.361 2.177 4.33 4.8.664-3.447 3.406z"
      />
    </g>
  </svg>
);

export default New;
